import { Zap } from "lucide-react";

export default function Navbar({ activeTab, setActiveTab }) {
  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <div className="brand-icon">
          <Zap size={20} strokeWidth={2.5} />
        </div>
        <span className="brand-name">
          Pear<span className="brand-accent">Media</span>
        </span>
        <span className="brand-tag">AI Studio</span>
      </div>

      <div className="nav-tabs">
        <button
          className={`nav-tab ${activeTab === "text" ? "active" : ""}`}
          onClick={() => setActiveTab("text")}
        >
          <span className="tab-number">01</span>
          <span className="tab-label">Creative Studio</span>
        </button>
        <button
          className={`nav-tab ${activeTab === "image" ? "active" : ""}`}
          onClick={() => setActiveTab("image")}
        >
          <span className="tab-number">02</span>
          <span className="tab-label">Style Lab</span>
        </button>
      </div>

      <div className="navbar-right">
        <span className="status-dot"></span>
        <span className="status-text">AI Online</span>
      </div>
    </nav>
  );
}
